export default "__VITE_ASSET__DlW_q5Xo__"